export const SET_WORKSPAN_DATA = "SET_WORKSPAN_DATA";

const initialState = {
  client_id: "",
  client_secret: "",
  disableWorkspanItems: false,
  workspan_submit_btn_disable: false,
  refetch_workspan: false,
  workspan_loading: false,
  confirm_workspan_reset_popup: false,
  cx_plan_ids: [],
  cx_mapping: {},
  gluVisibility: true,
  hasSavedCredentials: false,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_WORKSPAN_DATA: {
      return { ...state, ...action.payload };
    }
    default:
      return state;
  }
};
